<footer class="footer">
  <div class="footer-content">
    <div class="footer-brand">
      <span class="logo">PRAD Academy</span>
      <div class="footer-bottom">
        <small>Plataforma de aprendizaje en línea  para<br> el desarrollo profesional en Costa Rica.</small>
    </div>
    </div>
    
    <nav class="footer-links">
      <div style="display: flex; flex-direction: column;">
        <a (click)="goToHome()">Inicio</a>
        <a (click)="actionFeedback()">Feedback</a>
        <a (click)="goToPolicies()">Políticas de seguridad</a>
      </div>      
    </nav>

    <div class="footer-social" style="gap: 1px;">
      <a href="https://www.facebook.com/share/17R1x2EcgM/?mibextid=wwXIfr" target="_blank">
        <mat-icon>facebook</mat-icon>
      </a>
      <a [href]="'https://wa.me/50672195203?text=Prad%20Academy,%20necesito%20ayuda.'" target="_blank">
        <mat-icon svgIcon="whatsapp" aria-hidden="false" aria-label="Example thumbs up SVG icon" style="width: 3.5em;"></mat-icon>
      </a>
      <a href="https://www.instagram.com/pradacademy/?igsh=bW92Mmp1bmI4ZmE0" target="_blank">
        <mat-icon svgIcon="instragram" aria-hidden="false" aria-label="Example thumbs up SVG icon" style="width: 1.5em;"></mat-icon>
      </a>
    </div>
  </div>

  <div class="footer-bottom">
    <small>&copy; 2025 PRAD Academy. Todos los derechos reservados.</small>
  </div>
</footer>
